module.exports = __webpack_public_path__ + "img/what-happens-desktop-fr@2x.98aa8418.webp";